import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  addRedirectionQrLocation,
  redirectionQrInterface,
} from "../api/UserRequest";
import logo from "../assests/zeeqr-black.svg";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";

function RedirectSolutionPage() {
  const params = useParams();
  const [redirectionQR, setRedirectionQR] = useState(false);
  const [loader, setLoader] = useState(true);

  // Helper function to ensure URL has proper protocol
  const formatUrl = (url) => {
    if (!url) return "";

    // If URL already has protocol, return as is
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    // If URL starts with www, add https://
    if (url.startsWith("www.")) {
      return `https://${url}`;
    }

    // If no protocol and no www, add https://
    return `https://${url}`;
  };

  //   useEffect(() => {
  //     const getRedirectionQRDetails = async () => {
  //       try {
  //         const path = {
  //           url: window.location.href,
  //         };
  //         const { data } = await redirectionQrInterface(params.id, path);

  //         if (data.success) {
  //           console.log(data);

  //           if (!data.cardType && data.cardType !== "trial") {
  //             console.log("here");

  //             const liveLocation = await axios.get("https://ipapi.co/json");
  //             await addRedirectionQrLocation(
  //               data.redirectionQR._id,
  //               liveLocation.data
  //             );
  //           }

  //           const redirectUrl = data?.redirectionQR?.redirectionUrl;

  //           if (redirectUrl) {
  //             setRedirectionQR(false);
  //             setLoader(false);

  //             // Format the URL properly before redirecting
  //             const formattedUrl = formatUrl(redirectUrl);
  //             console.log("Redirecting to:", formattedUrl);

  //             // Use setTimeout to ensure state updates are processed
  //             setTimeout(() => {
  //               window.location.href = formattedUrl;
  //             }, 100);
  //           } else {
  //             // No redirect URL found
  //             setRedirectionQR(true);
  //             setLoader(false);
  //           }
  //         } else {
  //           setRedirectionQR(true);
  //           setLoader(false);
  //         }
  //       } catch (error) {
  //         console.log("Redirect error:", error);
  //         setRedirectionQR(true);
  //         setLoader(false);
  //       }
  //     };

  //     getRedirectionQRDetails();
  //   }, [params.id]);
  useEffect(() => {
    const getRedirectionQRDetails = async () => {
      try {
        const path = {
          url: window.location.href,
        };
        const { data } = await redirectionQrInterface(params.id, path);

        if (data.success) {

          // Check if user can use the location API
          const cardType = data?.redirectionQR?.cardType;
          const formType = data?.redirectionQR?.formType;
          // const canUseLocationAPI = !cardType || cardType === "";
          const canUseLocationAPI = !cardType && !formType;

          if (canUseLocationAPI) {
            console.log("User can use location API - tracking location");
            const liveLocation = await axios.get("https://ipapi.co/json");
            await addRedirectionQrLocation(
              data.redirectionQR._id,
              liveLocation.data
            );
          }

          const redirectUrl = data?.redirectionQR?.redirectionUrl;

          if (redirectUrl) {
            setRedirectionQR(false);
            setLoader(false);

            // Format the URL properly before redirecting
            const formattedUrl = formatUrl(redirectUrl);
            console.log("Redirecting to:", formattedUrl);

            // Use setTimeout to ensure state updates are processed
            setTimeout(() => {
              window.location.href = formattedUrl;
            }, 100);
          } else {
            // No redirect URL found
            setRedirectionQR(true);
            setLoader(false);
          }
        } else {
          setRedirectionQR(true);
          setLoader(false);
        }
      } catch (error) {
        console.log("Redirect error:", error);
        setRedirectionQR(true);
        setLoader(false);
      }
    };

    getRedirectionQRDetails();
  }, [params.id]);
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 60,
              color: "black",
            }}
            spin
          />
        }
        spinning={loader}
      >
        {redirectionQR ? (
          <div className="w-full h-screen flex flex-col items-center justify-center">
            <img src={logo} alt="ZeeQR Logo" />
            <h1 className="font-bold mt-2">
              This card is not valid/card has expired!
            </h1>
            <p className="mt-1">Please contact the admin</p>
            <Link
              to={"https://wa.me/+971505363704?text=Hi%2C"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="p-2 mt-3 border-2 rounded-xl border-black hover:bg-black hover:text-white transition-colors">
                Get In Touch
              </button>
            </Link>
          </div>
        ) : (
          // Optional: Show redirecting message while redirect is happening
          <div className="text-center">
            <p className="text-lg text-gray-600">Redirecting...</p>
          </div>
        )}
      </Spin>
    </div>
  );
}

export default RedirectSolutionPage;
